exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TextArea-module__TextArea___32In4{width:100%}.TextArea-module__TextArea___32In4 textarea{width:100%;resize:vertical;background-color:transparent;min-height:150px;height:225px;max-height:60vh;font-family:Akzidenz-Grotesk;color:#646464;font-size:18px;border:none;background-attachment:local;background-image:linear-gradient(90deg,transparent,transparent 10px,transparent 0),linear-gradient(270deg,transparent,transparent 10px,transparent 0),repeating-linear-gradient(transparent,transparent 35px,#646464 0,#646464 36px);line-height:36px;padding:18px/3 10px}", ""]);

// exports
exports.locals = {
	"TextArea": "TextArea-module__TextArea___32In4"
};